const stringTrueValue = 'yes';
const stringFalseValue = 'no';
export default function abSwitch(req) {
  const {
    abtesting
  } = req.query;
  let abTestingEnabled = true;

  if (abtesting && (abtesting === stringTrueValue || abtesting === stringFalseValue)) {
    abTestingEnabled = abtesting === stringTrueValue;
  }

  return abTestingEnabled;
}